import {
    Box,
    Button,
    Grid,
    TextField,
} from "@mui/material";
import React from "react";
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';

const FilterSection = ({
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    onFilter,
    onClearFilter
}) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4} md={2}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Từ ngày"
                        type="date"
                        value={startDate}
                        onChange={(e) => onStartDateChange(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: 'white',
                                '& fieldset': {
                                    borderColor: '#d9d9d9',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#40a9ff',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#40a9ff',
                                    borderWidth: '1px',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '0.875rem',
                            }
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={4} md={2}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Đến ngày"
                        type="date"
                        value={endDate}
                        onChange={(e) => onEndDateChange(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                backgroundColor: 'white',
                                '& fieldset': {
                                    borderColor: '#d9d9d9',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#40a9ff',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#40a9ff',
                                    borderWidth: '1px',
                                },
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '0.875rem',
                            }
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={12} md={8}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <Button
                            variant="contained"
                            startIcon={<SearchIcon />}
                            onClick={onFilter}
                            sx={{
                                textTransform: 'none',
                                backgroundColor: '#1976d2',
                                height: '40px',
                                fontWeight: 400,
                                fontSize: '0.875rem',
                                px: 2.5,
                                boxShadow: 'none',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                    boxShadow: 'none',
                                }
                            }}
                        >
                            Tìm kiếm
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<RefreshIcon />}
                            onClick={onClearFilter}
                            sx={{
                                textTransform: 'none',
                                backgroundColor: '#d32f2f',
                                height: '40px',
                                fontWeight: 400,
                                fontSize: '0.875rem',
                                px: 2.5,
                                boxShadow: 'none',
                                '&:hover': {
                                    backgroundColor: '#b71c1c',
                                    boxShadow: 'none',
                                }
                            }}
                        >
                            Đặt lại
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FilterSection;
